import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProductionForm, ProductionFormPartType } from '../../production-form/production-form.component'
import { Production } from '../../production.schema'

interface ProductionEditProps extends ModalProps {
  production: Production
  onCancel: () => void
  formPartType?: ProductionFormPartType
}

export const ProductionEdit: React.FC<ProductionEditProps> = ({ production, formPartType, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { run: updateProduction, loading } = useRequest(
    (data) => ({
      url: `/api/production/patch/${production.selfId}`,
      method: 'patch',
      data,
    }),
    {
      manual: true,
      onSuccess: () => {
        props.onCancel()
      },
    }
  )

  return (
    <Modal
      destroyOnClose
      width={'80%'}
      maskClosable={false}
      title={
        <div className='font-normal'>
          <h2 className='text-[21px] leading-normal'>
            {t('edit')}：{production.name}
          </h2>
          <p className='text-[14px] leading-normal'>
            <div>{t('production.form.description1')}</div>
            <div>{t('production.form.description2')}</div>
            <div>{t('production.form.description3')}</div>
          </p>
        </div>
      }
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form?.submit()}
      {...props}
    >
      {production && (
        <ProductionForm
          form={form}
          formPartType={formPartType}
          loading={loading}
          production={production}
          onSubmit={updateProduction}
        />
      )}
    </Modal>
  )
}
